import styled, { css } from "styled-components";
import { Heading, Paragraph } from "../../../atoms/Typography/Typography.styles";

export const HeroProfileWrapper = styled.div`
  background-color: ${({ theme }) => theme.colorScheme['darkGreen'].surface.inside};
  padding: ${({ theme }) => theme.rem(32, 0)};
  overflow: hidden;

  ${({ theme }) => theme.mediaQuery.xl(`
    padding: ${theme.rem(132, 0)};
  `)}
`;

export const HeroProfileUserData = styled.div`
  width: 100%;
  margin: 0 auto ${({ theme }) => theme.rem(24)};

  ${({ theme }) => theme.mediaQuery.xl(`
    margin: 0 auto;
    padding-top: ${theme.rem(48)};
  `)}

  ${Heading},
  ${Paragraph} {
    text-transform: capitalize;
  }

  ${Paragraph} {
    color: white;
  }
`;

export const HeroProfileImageWrapper = styled.div`
  position: absolute;
  width: 100%;
  aspect-ratio: 16 / 16;
  z-index: -1;
  border-radius: ${({ theme }) => theme.rem(24)};

  background-color: ${({ theme }) => theme.colorScheme['darkGreen'].surface.inside};

  ${({ theme }) => theme.mediaQuery.xl(`
    aspect-ratio: 16 / 10;
  `)}
  
  img {
    overflow: hidden;
    object-fit: cover;
    object-position: center;
  }
`;

export const HeroProfileIconWrapper = styled.div<{ position: 'top-right' | 'bottom-left' }>`
  position: absolute;
  z-index: 10;
  display: none;

  ${({ theme }) => theme.mediaQuery.xl(`
    display: block;
  `)}

  ${({ position, theme }) => position === 'bottom-left' && css`
    bottom: 0;
    left: 0;

    ${theme.mediaQuery.xl(`
      left: ${theme.rem(-186)};
      bottom: ${theme.rem(-56)};
      i {
        font-size: ${theme.rem(208)};
      }
    `)}
  `};

  ${({ position, theme }) => position === 'top-right' && css`
    top: 0;
    right: 0;

    ${theme.mediaQuery.xl(`
      right: ${theme.rem(-32)};
      top: ${theme.rem(-82)};
      i {
        font-size: ${theme.rem(214)};
      }
    `)}
  `};
`;

export const HeroProfileUploadWrapper = styled.div`
  position: relative;
`;

export const HeroProfileUploadFormWrapper = styled.div<{ show: boolean }>`
  width: 100%;
  min-height: 100%;
  z-index: 1;
  background-color: ${({ theme }) => theme.colorScheme['lightGreen'].surface.inside};
  border-radius: ${({ theme }) => theme.rem(24)};
  display: ${({ show }) => show ? 'block' : 'none'};
`;

export const HeroProfileImageText = styled.div<{ show: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  padding: ${({ theme }) => theme.rem(24)};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 3;
  aspect-ratio: 16 / 16;
  transition: all 0.2s ease-out;

  ${Heading},
  ${Paragraph} {
    color: white;
  }

  ${({ show }) => !show && css`
    display: none;
  `}

  ${({ theme }) => theme.mediaQuery.xl(`
    padding: ${theme.rem(0, 92)};
    aspect-ratio: 16 / 10;
  `)}
`

export const HeroProfileImageTextButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(16)};

  ${({ theme }) => theme.mediaQuery.xl(`
    flex-direction: row;
  `)}
`

export const HeroProfileInvalidContestWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`